import {SectionView} from '@/shared/components/legalDocuments/sectionView';

import {GUIDELINES} from './consts';

const CommunityGuidelines = () => {
  return (
    <>
      <div className="mt-10 mb-8 flex flex-col gap-1 px-6 sm:px-12">
        <p className="mb-4 font-semibold text-4xl text-primary italic">
          Welcome to Bumpy!
        </p>
        <p>
          At Bumpy, we strive to create a welcoming, safe, and inclusive
          environment where you can be your true self and make meaningful
          connections. By adhering to these guidelines, you help us maintain
          this atmosphere and ensure a positive experience for all users.
        </p>
        <p>
          These Community Guidelines apply equally to Bumpy (bumpy.app) and to
          app Wonder (wonder.dating) - both are operated by the same team, held
          to the same standards, and enforced in the same way. Wherever you see
          “Bumpy” below, read it as covering Wonder too.
        </p>
        <p>
          These Community guidelines constitute rules of community in Bumpy App
          and/or Wonder App, the rules are not limited to the following list,
          they can be extended any time, as some of wrongful and harmful
          behaviour can be hard to predict beforehand.
        </p>
      </div>
      <div className="flex flex-col gap-8 px-6 sm:px-12">
        {GUIDELINES.map((section, index) => (
          <SectionView
            key={`static-${index}`}
            paragraphName={index + 1}
            section={section}
          />
        ))}
      </div>
      <div className="mt-8 flex flex-col gap-1 px-6 sm:px-12">
        <p className="mb-4 font-semibold text-4xl text-primary italic">
          Reporting and Enforcement
        </p>
        <p>
          We encourage you to report any activities or behavior that violate
          these guidelines. We take each report seriously and will take
          appropriate actions to maintain community standards. You can report a
          profile, message, or photo directly from the app, or contact our
          support team. Depending on the severity and frequency of a violation,
          we may issue a warning, restrict certain features, limit a profile’s
          visibility, or suspend or permanently terminate an account, as
          described in our Terms of Service; you can appeal an enforcement
          decision through support.
        </p>
        <p>
          By following these Guidelines, you contribute to a trustworthy and
          engaging environment for all Bumpy and Wonder users. Let’s keep Bumpy
          and Wonder positive spaces for everyone!
        </p>
      </div>
    </>
  );
};

export default CommunityGuidelines;
